import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

import { Error, TipoActividad } from '@rpe/registro-personas-empresas-lib';

export const entityTiposActividadAdapter: EntityAdapter<TipoActividad> =
  createEntityAdapter<TipoActividad>({
    selectId: (model) => model.id,
    sortComparer: (a: TipoActividad, b: TipoActividad): number =>
      a.nombre?.toString().localeCompare(b.nombre?.toString())
  });

export interface EntityTiposActividadState extends EntityState<TipoActividad> {
  isLoading?: boolean;
  error?: Error | null;
}

export const initialState: EntityTiposActividadState =
  entityTiposActividadAdapter.getInitialState({
    isLoading: false,
    error: null
  });
